import { shape, string } from 'prop-types'

export const OfferType = shape({
  offerId: string.isRequired,
})
